// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1AP7e","buttonText":"button-module--buttonText--3Eb2e","disabled":"button-module--disabled--1OblY","black":"button-module--black--3tj-T"};